<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.children, item)">
      <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown': !isNest}">
          <span class="sidebar-title-wrap">
            <item :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)" :title="onlyOneChild.meta.title" />
            <el-badge v-if="approvalTodoCount(resolvePath(onlyOneChild.path)) > 0" :value="approvalTodoCount(resolvePath(onlyOneChild.path))" class="sidebar-menu-badge" />
          </span>
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else :index="resolvePath(item.path)" teleported>
      <template slot="title">
        <span class="sidebar-title-wrap">
          <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
          <el-badge v-if="approvalTodoSubtreeCount > 0" :value="approvalTodoSubtreeCount" class="sidebar-menu-badge" />
        </span>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.path)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path-browserify'
import { isExternal } from '../utils/validate'
import Item from './Item'
import AppLink from './Link'

export default {
  name: 'SidebarItem',
  components: {
    Item,
    AppLink
  },
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null
    return {}
  },
  computed: {
    /** 当前菜单项子树内，所有 /approval/<分组>/:flowCode 待办之和（含多级子菜单） */
    approvalTodoSubtreeCount() {
      return this.sumApprovalTodosInSubtree(this.item, this.basePath)
    }
  },
  methods: {
    /**
     * nodeFullPath：本节点在侧栏中的绝对路径（与父组件传入的 base-path 一致，不再与 node.path 二次拼接）
     */
    sumApprovalTodosInSubtree(node, nodeFullPath) {
      if (!node || node.hidden) return 0
      const normalized = (nodeFullPath || '').replace(/\/+/g, '/')
      let sum = this.approvalTodoCount(normalized)
      for (const child of node.children || []) {
        if (child.hidden) continue
        const childFull = this.resolvePathBetween(normalized, child.path)
        sum += this.sumApprovalTodosInSubtree(child, childFull)
      }
      return sum
    },
    resolvePathBetween(basePath, routePath) {
      if (isExternal(routePath)) return routePath
      if (isExternal(basePath)) return basePath
      return path.resolve(basePath || '/', routePath || '').replace(/\/+/g, '/')
    },
    approvalTodoCount(fullPath) {
      const m = (fullPath || '').match(/^\/approval\/[^/]+\/([^/]+)$/)
      if (!m) return 0
      return this.$store.getters['approval/todoCount'](m[1]) || 0
    },
    hasOneShowingChild(children = [], parent) {
      // 如果设置了 alwaysShow 为 true，始终显示父级菜单
      if (parent.alwaysShow) {
        return false
      }

      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      return this.resolvePathBetween(this.basePath, routePath)
    }
  }
}
</script>